export default {
  root: {
    borderRadius: 5,
    boxShadow: 'none'
  },
  contained: {}
};
